<app-auth-card
  (acessar)="onAcessar()"
  (visitante)="onVisitante()"
  [buttonVisitanteVisibility]="redeInterna()"
  [message]="mensagem()"
></app-auth-card>
